import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * GROWTH-7922: /paid-leads and /paid-leads/:id answer with the same page at its /paid-referrals address. The query string (tab,
 * page, per_page, user_id, return params), the hash and any router state ride along, so a bookmark or an email link lands where
 * it always did. Replaces the entry, so Back does not return to the old address and bounce forward again.
 *
 * @param {Object} props
 * @param {string} props.to the new list path
 * @param {boolean} [props.withId] append the route's :id
 */
const RedirectKeepingQuery = ({ to, withId = false }) => {
  const { id } = useParams();
  const { search, hash, state } = useLocation();

  return <Navigate replace to={`${to}${withId && id ? `/${encodeURIComponent(id)}` : ""}${search}${hash}`} state={state} />;
};

export default RedirectKeepingQuery;
